import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';
import Header from './components/header/Header';
import Hero from './components/hero/Hero';
import About from './components/about/About';
import Values from './components/values/Values';
import Experience from './components/experience/Experience';
import Video from './components/video/Video';
import Footer from './components/footer/Footer';
import NotFound from './components/notfound/NotFound';
import CookieBanner from './components/cookie/CookieBanner';
import './scripts/script.js';

// Ana sayfa component'i
const HomePage = () => (
  <>
    <Hero />
    <About />
    <Values />
    <Experience />
    <Video />
  </>
);

function App() {
  useEffect(() => {
    // AOS Initialize - HTML'deki ayarlarla aynı
    AOS.init({
      duration: 800,
      once: true,
      offset: 100
    });

    // Go Top Button functionality
    const goTopBtn = document.getElementById('goTopBtn');
    
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > 300) {
        goTopBtn.classList.add('show');
      } else {
        goTopBtn.classList.remove('show');
      }
    };

    const scrollToTop = (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Smooth scroll to top with custom animation
      const startPosition = window.pageYOffset;
      const duration = 1000; // 1 saniye
      let start = null;

      const step = (timestamp) => {
        if (!start) start = timestamp;
        const progress = timestamp - start;
        const percentage = Math.min(progress / duration, 1);
        
        // Easing function
        const easeInOutCubic = percentage < 0.5 
          ? 4 * percentage * percentage * percentage 
          : (percentage - 1) * (2 * percentage - 2) * (2 * percentage - 2) + 1;
        
        window.scrollTo(0, startPosition * (1 - easeInOutCubic));
        
        if (progress < duration) {
          requestAnimationFrame(step);
        }
      };

      requestAnimationFrame(step);
    };

    if (goTopBtn) {
      window.addEventListener('scroll', handleScroll);
      goTopBtn.addEventListener('click', scrollToTop);
    }

    // Cleanup
    return () => {
      if (goTopBtn) {
        window.removeEventListener('scroll', handleScroll);
        goTopBtn.removeEventListener('click', scrollToTop);
      }
    };
  }, []);

  return (
    <Router>
      <div className="App">
        <Header />
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        
        <Footer />
        
        <CookieBanner />

        {/* Go Top Button */}
        <button id="goTopBtn" className="go-top-button" title="Yukarı Git" type="button">
          <img src="icons/arrow-up.svg" alt="Yukarı Git" />
        </button>
      </div>
    </Router>
  );
}

export default App;
